// eslint-disable-next-line no-restricted-imports
import { useSelector } from 'react-redux';
import { WidgetState } from './widget-state.type';

const useActions = () => {
  return useSelector((state: WidgetState) => state.actions);
};

export default useActions;
